<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.quality.marks.weights.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.quality.marks.weights.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
            <tr class="_titlePartTable">
                <th></th>
                <th [i18nKey]="'parameters.quality.marks.weights.weight.on.qualities'"></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td [i18nKey]="'parameters.quality.marks.weights.advertisement'"></td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.advertisementAssignmentWeight"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.marks.weights.menu'"></td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.ingredientsPurchasesAssignmentWeight"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.marks.weights.customer.care'"></td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.customerCareAssignmentWeight"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.quality.marks.weights.cooking'"></td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.cookingAssignmentWeight"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
        </tbody>
    </table>
</div>
